// src/pages/TrainingPrograms.js - COMBINED WORKSHOPS & CUSTOM TRAINING WITH PHOTOS
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TrainingPrograms.css';
import Footer from '../components/Footer';
import AnimatedHeroBackground from '../components/AnimatedHeroBackground';

const TrainingPrograms = () => {
  const [activeTab, setActiveTab] = useState('workshops');
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [formData, setFormData] = useState({
    collegeName: '',
    contactPerson: '',
    email: '',
    phone: '',
    department: '',
    studentsCount: '',
    trainingType: '',
    duration: '',
    additionalRequirements: ''
  });

  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Custom Training Request:', formData);
    alert('Thank you! We will contact you within 24 hours with a custom proposal.');
  };

  const workshops = [
    {
      id: 1,
      icon: '🔧',
      title: 'Data Engineering',
      duration: '3-5 Days',
      rating: '4.7/5',
      students: '200+',
      color: '#2563EB',
      description: 'Build robust data pipelines and infrastructure',
      topics: [
        'ETL Pipeline Development',
        'Apache Spark & Hadoop',
        'Data Warehousing Concepts',
        'Cloud Data Platforms (AWS/Azure)',
        'Real-time Data Processing',
        'Data Quality & Validation'
      ]
    },
    {
      id: 2,
      icon: '📊',
      title: 'Data Science & Analytics',
      duration: '3-5 Days',
      rating: '4.8/5',
      students: '250+',
      color: '#10B981',
      description: 'Master data analysis and visualization techniques',
      topics: [
        'Python for Data Analysis',
        'Statistical Analysis',
        'Data Visualization (Matplotlib, Seaborn)',
        'Exploratory Data Analysis (EDA)',
        'Tableau / Power BI',
        'Predictive Analytics'
      ]
    },
    {
      id: 3,
      icon: '🤖',
      title: 'Machine Learning',
      duration: '4-5 Days',
      rating: '4.9/5',
      students: '180+',
      color: '#8B5CF6',
      description: 'Hands-on ML model building and deployment',
      topics: [
        'ML Fundamentals & Algorithms',
        'Supervised & Unsupervised Learning',
        'Feature Engineering',
        'Model Training & Evaluation',
        'Scikit-learn & TensorFlow',
        'ML Model Deployment'
      ]
    },
    {
      id: 4,
      icon: '✨',
      title: 'LLMs & Generative AI',
      duration: '3-5 Days',
      rating: '5.0/5',
      students: '300+',
      color: '#F59E0B',
      description: 'Build applications with cutting-edge AI',
      topics: [
        'Large Language Models Introduction',
        'Prompt Engineering Techniques',
        'OpenAI API & ChatGPT Integration',
        'LangChain Framework',
        'Vector Databases & RAG',
        'Building AI Applications'
      ]
    },
    {
      id: 5,
      icon: '🕷️',
      title: 'Web Scraping & Automation',
      duration: '2-3 Days',
      rating: '4.6/5',
      students: '220+',
      color: '#EF4444',
      description: 'Extract data from websites efficiently',
      topics: [
        'Python BeautifulSoup & Selenium',
        'Web Scraping Best Practices',
        'Handling Dynamic Content',
        'Data Extraction & Storage',
        'API Integration',
        'Ethical Scraping Practices'
      ]
    },
    {
      id: 6,
      icon: '☁️',
      title: 'Cloud Computing (AWS/Azure)',
      duration: '4-5 Days',
      rating: '4.7/5',
      students: '190+',
      color: '#06B6D4',
      description: 'Deploy applications on cloud platforms',
      topics: [
        'Cloud Computing Fundamentals',
        'AWS/Azure Services Overview',
        'Virtual Machines & Storage',
        'Serverless Computing',
        'Database Services',
        'Cloud Security Basics'
      ]
    }
  ];

  const features = [
    { icon: '👨‍🏫', title: 'Expert Trainers' },
    { icon: '💻', title: 'Hands-on Labs' },
    { icon: '🎓', title: 'Certificates' },
    { icon: '📚', title: 'Course Materials' },
    { icon: '🏢', title: 'On-Campus/Online' },
    { icon: '💼', title: 'Real Projects' }
  ];

  const customizationOptions = [
    {
      icon: '📚',
      title: 'Curriculum Design',
      description: 'Choose topics & modules tailored to your needs'
    },
    {
      icon: '⏱️',
      title: 'Flexible Duration',
      description: '2 days to 6 months - You decide the timeline'
    },
    {
      icon: '👥',
      title: 'Any Batch Size',
      description: 'On-campus/Online/Hybrid - Flexible delivery modes'
    },
    {
      icon: '🎯',
      title: 'Custom Outcomes',
      description: 'Define specific skills and competencies'
    },
    {
      icon: '💼',
      title: 'Industry Projects',
      description: 'Real-world experience with live projects'
    },
    {
      icon: '🎓',
      title: 'Faculty Training',
      description: 'Train your staff too - Co-delivery options'
    }
  ];

  const successStories = [
    {
      college: 'IAER Engineering College',
      requirement: 'Custom ML program for CSE department',
      solution: '6-week tailored curriculum with CV projects',
      outcome: '85 students trained, 20+ projects built'
    },
    {
      college: 'VNR Institute of Technology',
      requirement: 'Data Science for faculty + students',
      solution: 'Tiered program with co-delivery model',
      outcome: '15 faculty + 120 students certified'
    },
    {
      college: 'St. Mary\'s College',
      requirement: 'GenAI Workshop for final year students',
      solution: '5-day intensive hands-on bootcamp',
      outcome: '60 students built & deployed AI apps'
    }
  ];

  return (
    <AnimatedHeroBackground>
      <div className="training-programs-page">
        {/* Hero Section */}
        <section className="training-hero">
          <div className="container">
            <div className="breadcrumb">
              <Link to="/for-colleges">For Colleges</Link> / <span>Training Programs</span>
            </div>

            <div className="hero-layout">
              {/* Left Side */}
              <div className="hero-left">
                <h1 className="hero-main-title">We Don't Just Train...</h1>
                <h2 className="hero-sub-title">
                  We Transform Students Into <span className="highlight-text">Industry Professionals!</span>
                </h2>
                <p className="hero-description">
                  Choose between ready-made intensive workshops or fully customized training programs 
                  designed specifically for your college's unique requirements.
                </p>
                <div className="hero-cta-buttons">
                  <Link to="/contact" className="hero-cta-btn primary">
                    Schedule Campus Demo 📅
                  </Link>
                  <a href="/Brochure_A4_FullBleed_v2.pdf" download className="hero-cta-btn secondary">
                    Download Brochure 📥
                  </a>
                </div>
              </div>

              {/* Right Side - Stats Boxes */}
              <div className="hero-stats">
                <div className="stat-box stat-box-1">
                  <div className="stat-icon">👥</div>
                  <div className="stat-number">1000+</div>
                  <div className="stat-label">Students Trained</div>
                </div>
                <div className="stat-box stat-box-2">
                  <div className="stat-icon">🏢</div>
                  <div className="stat-number">10+</div>
                  <div className="stat-label">Partner Colleges</div>
                </div>
                <div className="stat-box stat-box-3">
                  <div className="stat-icon">⭐</div>
                  <div className="stat-number">4.8/5</div>
                  <div className="stat-label">Average Rating</div>
                </div>
                <div className="stat-box stat-box-4">
                  <div className="stat-icon">🎯</div>
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Customizable</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Tabs Navigation */}
        <section className="tabs-section">
          <div className="container">
            <div className="tabs-nav">
              <button 
                className={`tab-btn ${activeTab === 'workshops' ? 'active' : ''}`}
                onClick={() => setActiveTab('workshops')}
              >
                WORKSHOPS
              </button>
              <button 
                className={`tab-btn ${activeTab === 'custom' ? 'active' : ''}`}
                onClick={() => setActiveTab('custom')}
              >
                CUSTOM TRAINING
              </button>
            </div>
          </div>
        </section>

        {/* Workshops Tab Content */}
        {activeTab === 'workshops' && (
          <>
            <section className="workshops-section">
              <div className="container">
                <h2 className="section-title">Available Workshops</h2>
                <p className="section-subtitle">Intensive 1-15 Day Programs • Expert Trainers • Certified</p>

                <div className="workshops-grid">
                  {workshops.map((workshop) => (
                    <div 
                      key={workshop.id} 
                      className="workshop-card"
                      style={{ '--workshop-color': workshop.color }}
                      onClick={() => setSelectedWorkshop(workshop)}
                    >
                      <div className="workshop-icon">{workshop.icon}</div>
                      <h3 className="workshop-title">{workshop.title}</h3>
                      <p className="workshop-description">{workshop.description}</p>
                      <div className="workshop-meta">
                        <span className="meta-duration">{workshop.duration}</span>
                        <span className="meta-rating">⭐ {workshop.rating}</span>
                      </div>
                      <div className="workshop-students">{workshop.students} trained</div>
                      <button className="workshop-btn">View More →</button>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="features-section">
              <div className="container">
                <h2 className="section-title">What's Included</h2>
                <div className="features-grid">
                  {features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <div className="feature-icon">{feature.icon}</div>
                      <div className="feature-title">{feature.title}</div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </>
        )}

        {/* Custom Training Tab Content */}
        {activeTab === 'custom' && (
          <section className="custom-training-section">
            <div className="container">
              <h2 className="section-title">Build Your Perfect Training Program</h2>
              <p className="section-subtitle">100% Customizable • Your Needs, Your Way</p>

              <div className="custom-layout">
                {/* Left - Form */}
                <div className="custom-form-container">
                  <form onSubmit={handleSubmit} className="custom-form">
                    <div className="form-group">
                      <label>🏫 College Name *</label>
                      <input
                        type="text"
                        name="collegeName"
                        value={formData.collegeName}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter college name"
                      />
                    </div>

                    <div className="form-group">
                      <label>👤 Contact Person *</label>
                      <input
                        type="text"
                        name="contactPerson"
                        value={formData.contactPerson}
                        onChange={handleInputChange}
                        required
                        placeholder="Your name"
                      />
                    </div>

                    <div className="form-group">
                      <label>📧 Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="email@college.edu"
                      />
                    </div>

                    <div className="form-group">
                      <label>📱 Phone *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        placeholder="+91 XXXXX XXXXX"
                      />
                    </div>

                    <div className="form-group">
                      <label>🎓 Department *</label>
                      <input
                        type="text"
                        name="department"
                        value={formData.department}
                        onChange={handleInputChange}
                        required
                        placeholder="e.g., CSE, IT, ECE"
                      />
                    </div>

                    <div className="form-group">
                      <label>👥 Number of Students</label>
                      <input
                        type="number"
                        name="studentsCount"
                        value={formData.studentsCount}
                        onChange={handleInputChange}
                        placeholder="e.g., 60"
                      />
                    </div>

                    <div className="form-group">
                      <label>📋 Training Type *</label>
                      <select
                        name="trainingType"
                        value={formData.trainingType}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="workshop">Workshop (2-5 days)</option>
                        <option value="short-program">Short Program (2-4 weeks)</option>
                        <option value="long-program">Long Program (1-6 months)</option>
                        <option value="faculty-training">Faculty Training</option>
                        <option value="mixed">Mixed (Students + Faculty)</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label>⏳ Preferred Duration</label>
                      <input
                        type="text"
                        name="duration"
                        value={formData.duration}
                        onChange={handleInputChange}
                        placeholder="e.g., 5 days, 3 weeks"
                      />
                    </div>

                    <div className="form-group form-group-full">
                      <label>📝 Additional Requirements</label>
                      <textarea
                        name="additionalRequirements"
                        value={formData.additionalRequirements}
                        onChange={handleInputChange}
                        rows="5"
                        placeholder="Share any specific requirements, learning objectives, preferred dates, delivery format..."
                      ></textarea>
                    </div>

                    <button type="submit" className="form-submit-btn">
                      Request Custom Proposal 🚀
                    </button>
                  </form>
                </div>

                {/* Right - Options */}
                <div className="custom-options">
                  {customizationOptions.map((option, index) => (
                    <div key={index} className="option-box">
                      <div className="option-icon">{option.icon}</div>
                      <div className="option-content">
                        <h3 className="option-title">{option.title}</h3>
                        <p className="option-description">{option.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Success Stories - Common */}
        <section className="success-stories-section">
          <div className="container">
            <h2 className="section-title">Success Stories</h2>
            <p className="section-subtitle">Real Results from Real Colleges</p>

            <div className="stories-grid">
              {successStories.map((story, index) => (
                <div key={index} className="story-card">
                  <div className="story-icon">🎓</div>
                  <h3 className="story-college">{story.college}</h3>
                  <div className="story-detail">
                    <strong>REQUIREMENT:</strong>
                    <p>{story.requirement}</p>
                  </div>
                  <div className="story-detail">
                    <strong>OUR SOLUTION:</strong>
                    <p>{story.solution}</p>
                  </div>
                  <div className="story-outcome">
                    <span className="outcome-badge">✅ OUTCOME</span>
                    <p>{story.outcome}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Training Photos - Common */}
        <section className="training-photos-section">
          <div className="container">
            <h2 className="section-title">Training In Action</h2>
            <p className="section-subtitle">Real Photos From Our Campus Sessions</p>

            <div className="photos-grid">
              {/* Large Main Photo */}
              <div className="photo-large">
                <img 
                  src="/training-photos/main-photo.jpg" 
                  alt="Workshop Session"
                  className="training-photo"
                />
              </div>

              {/* Small Photo 1 */}
              <div className="photo-small">
                <img 
                  src="/training-photos/photo1.jpg" 
                  alt="Students attending training session"
                  className="training-photo"
                />
              </div>

              {/* Small Photo 2 */}
              <div className="photo-small">
                <img 
                  src="/training-photos/photo2.jpg" 
                  alt="Hands-on coding workshop"
                  className="training-photo"
                />
              </div>

              {/* Medium Photo 3 */}
              <div className="photo-medium">
                <img 
                  src="/training-photos/photo3.jpg" 
                  alt="Instructor explaining concepts to students"
                  className="training-photo"
                />
              </div>

              {/* Medium Photo 4 */}
              <div className="photo-medium">
                <img 
                  src="/training-photos/iare2.jpg" 
                  alt="Classroom-based technical training"
                  className="training-photo"
                />
              </div>

              {/* Medium Photo 5 */}
              <div className="photo-medium">
                <img 
                  src="/training-photos/vnr-2.jpg" 
                  alt="Students working on laptops during session" 
                  className="training-photo"
                />
              </div>

              {/* Medium Photo 6 */}
              <div className="photo-medium">
                <img 
                  src="/training-photos/photo6.jpg" 
                  alt="Live campus workshop environment"
                  className="training-photo"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Workshop Modal */}
        {selectedWorkshop && (
          <div className="modal-overlay" onClick={() => setSelectedWorkshop(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setSelectedWorkshop(null)}>×</button>
              <div className="modal-header" style={{ background: selectedWorkshop.color }}>
                <div className="modal-icon">{selectedWorkshop.icon}</div>
                <h2>{selectedWorkshop.title}</h2>
                <p>Duration: {selectedWorkshop.duration}</p>
              </div>
              <div className="modal-body">
                <h3>What You'll Learn</h3>
                <ul className="modal-topics">
                  {selectedWorkshop.topics.map((topic, index) => (
                    <li key={index}>
                      <span className="topic-check">✓</span>
                      {topic}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="modal-cta-btn">
                  Schedule This Workshop
                </Link>
              </div>
            </div>
          </div>
        )}

        {/* Final CTA */}
        <section className="final-cta">
          <div className="container">
            <h2>Ready to Transform Your Students?</h2>
            <p>Get started with workshops or custom training today</p>
            <div className="cta-buttons">
              <Link to="/contact" className="cta-btn primary">
                Contact Us 📞
              </Link>
              <a href="/Brochure_A4_FullBleed_v2.pdf" download className="cta-btn secondary">
                Download Brochure 📥
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </AnimatedHeroBackground>
  );
};

export default TrainingPrograms;